import { Modal, ModalHeader } from '@zocdoc/components/src/modal';
import { filterToValidAttributes } from '@zocdoc/dom-property';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import InsuranceList from '../InsuranceList';
import ViewAll from '../ViewAll';
import { LOCALIZED_STRINGS } from './constants';
import Preview from './preview';

export default class InNetworkInsuranceModule extends React.PureComponent {
    static propTypes = {
        insurances: PropTypes.arrayOf(PropTypes.object),
        onModalDismissed: PropTypes.func,
        showDetails: PropTypes.bool,
        viewAll: PropTypes.func,
    };

    static defaultProps = {
        insurances: [],
        onModalDismissed: noop,
        showDetails: false,
        viewAll: noop,
    };

    render() {
        return (
            <div {...filterToValidAttributes(this.props)}>
                <Preview
                    data-test="in-network-insurance-module-preview"
                    insurances={this.props.insurances}
                />

                <ViewAll
                    data-test="in-network-insurance-module-view-all"
                    onClick={this.props.viewAll}
                />

                {this.maybeRenderDetails()}
            </div>
        );
    }

    maybeRenderDetails() {
        const { onModalDismissed, showDetails, insurances } = this.props;

        if (showDetails) {
            return (
                <Modal
                    data-test="in-network-insurance-module-modal"
                    onClickCancel={onModalDismissed}
                >
                    <ModalHeader>
                        <FormattedMessage {...LOCALIZED_STRINGS.InsuranceModalHeader} />
                    </ModalHeader>

                    <InsuranceList insurances={insurances} />
                </Modal>
            );
        }
    }
}

